import { Box, Grid, Typography } from "@mui/material";

const features = [
  {
    icon: (
      <Box
        component="i"
        className="fa-regular fa-envelope"
        sx={{ fontSize: 24 }}
      />
    ),
    iconBg: "#E8F36D",
    title: "AI-Powered Pitches",
    subtitle:
      "Stop writing emails from scratch. Our AI creates personalized pitches that sound like you and get responses.",
  },
  {
    icon: (
      <Box
        component="i"
        className="fa-regular fa-stars"
        sx={{ fontSize: 24 }}
      />
    ),
    iconBg: "#C8B6FF",
    title: "Smart Follow-Ups",
    subtitle:
      "Never miss an opportunity. Automated follow-ups and reminders help you close more deals.",
  },
  {
    icon: (
      <Box
        component="i"
        className="fa-regular fa-arrow-trend-up"
        sx={{ fontSize: 24, color: "white" }}
      />
    ),
    iconBg: "#2D4A3E",
    title: "600k+ Contacts",
    subtitle:
      "Access verified brand contacts with filters to find perfect matches for your niche.",
  },
];

const AnnualFeatures = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#F9FAFB",
        px: { xs: 3, md: 6 },
        py: { xs: 5, md: 6 },
        justifyContent: "center",
        display: "flex",
      }}
    >
      <Grid container spacing={4} sx={{ maxWidth: 1000 }}>
        {features.map((f) => (
          <Grid key={f.title} item xs={12} md={4}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "12px",
                  backgroundColor: f.iconBg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {f.icon}
              </Box>

              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "#101828" }}
              >
                {f.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{ color: "#667085", lineHeight: 1.65 }}
              >
                {f.subtitle}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AnnualFeatures;
